import { motion } from "framer-motion";
import { Check } from "lucide-react";
import { founderPhoto } from "@/assets/performance/photos";

const bullets = [
  "12+ years in dentistry",
  "Experience across multiple dental specialties",
  "Dental operations and leadership background",
  "Practice management and conversion support experience",
  "Strong understanding of patient flow, recare, reviews, hygiene growth, and treatment presentation",
  "Marketing built around real dental systems, not random content",
];

const FounderSection = () => {
  return (
    <section id="why-dental" className="section-padding section-navy">
      <div className="max-w-4xl mx-auto">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 0.6 }}
          className="text-center"
        >
          <p className="text-primary font-semibold tracking-[0.2em] uppercase text-sm mb-4">
            Why Dental
          </p>
          <h2 className="font-heading text-3xl md:text-4xl lg:text-5xl mb-8 text-white">
            Built by someone who understands what happens <span className="gold-gradient-text">after the lead comes in.</span>
          </h2>
        </motion.div>

        <motion.div
          initial={{ opacity: 0, y: 40, scale: 0.97 }}
          whileInView={{ opacity: 1, y: 0, scale: 1 }}
          viewport={{ once: true, margin: "-60px" }}
          transition={{ duration: 0.7, ease: "easeOut" }}
          className="card-glass p-10 md:p-14 flex flex-col md:flex-row gap-10 items-center"
        >
          <img
            src={founderPhoto.src}
            srcSet={founderPhoto.srcSet}
            sizes="(min-width: 768px) 224px, 192px"
            width={512}
            height={326}
            loading="lazy"
            decoding="async"
            alt="Nathaniel Santiago, Founder of N. Santiago Media"
            className="w-48 h-48 md:w-56 md:h-56 rounded-2xl object-cover object-top shadow-xl flex-shrink-0"
          />
          <div>
            <h3 className="font-heading text-2xl md:text-3xl mb-2 gold-gradient-text">
              Nathaniel Santiago
            </h3>
            <p className="text-primary text-sm font-semibold tracking-widest uppercase mb-6">
              Founder — N. Santiago Media
            </p>
            <div className="space-y-4 text-white/70 leading-relaxed">
              <p>
                My experience in dental started before marketing.
              </p>
              <p>
                I began in dentistry as a dental assistant in the U.S. Army, where I served and worked across multiple dental specialties. That experience eventually grew into operations leadership, giving me a deeper understanding of patient flow, team systems, clinical support, and what it takes for a dental operation to run well.
              </p>
              <p>
                After the Army, I continued in dentistry through practice management and conversion support with Heartland Dental. That work gave me hands-on experience with dental systems, front desk workflows, recare, reviews, hygiene growth, treatment presentation, patient experience, and the operational details that directly affect practice growth.
              </p>
              <p>
                That background is why N. Santiago Media is built differently.
              </p>
              <p>
                The marketing is not based on trends, guesses, or random content. It is built from understanding how dental clinics actually operate, where patients are often lost, and what systems need to be in place for visibility to turn into trust — and trust into scheduled patients.
              </p>
              <ul className="space-y-2 pt-2">
                {bullets.map((b) => (
                  <li key={b} className="flex items-start gap-3 text-white/80">
                    <Check className="w-5 h-5 text-primary flex-shrink-0 mt-0.5" />
                    <span>{b}</span>
                  </li>
                ))}
              </ul>
            </div>
          </div>
        </motion.div>
      </div>
    </section>
  );
};

export default FounderSection;
